import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", to: "/" },
  { label: "About me", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Contact me", to: "/contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-black text-white py-6 fixed w-full z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo - reduced font size on mobile */}
          <div className="text-xl sm:text-2xl font-bold">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <span className="text-white">PORT</span>
              <span className="text-blue-400">FOLIO</span>
            </Link>
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {links.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  `text-gray-300 hover:text-blue-400 transition-colors font-medium capitalize ${
                    isActive ? "text-blue-400" : ""
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
            <Link to="/contact">
              <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-all hover:scale-105">
                Collaborate
              </button>
            </Link>
          </div>
          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-gray-900 rounded-lg transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <X size={24} className="text-blue-400" />
            ) : (
              <Menu size={24} className="text-white" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isOpen ? "max-h-96" : "max-h-0"
          }`}
        >
          <div className="flex flex-col space-y-4 px-2 py-6 mt-4 border-t border-gray-800">
            {links.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `text-gray-300 hover:text-blue-400 transition-colors capitalize py-2 ${
                    isActive ? "text-blue-400" : ""
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setIsOpen(false)}>
              <button className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-all w-full">
                Collaborate
              </button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
